import { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import KogKeyboardDatePickerContainer from "@/main/components/shared/datepicker/keyboardDatePickerContainer";
import { DefaultValueParameterEnum } from "@/main/services/enum/DefaultValueParameterEnum";
import { GeneralVariableType, useDynamicFiltersExport } from "./dynamicFiltersExport";
import { onLoadDateRangePicker } from "@/main/services/utilsDate";

interface IVariableTypeRangeDateProps extends GeneralVariableType {}
function VariableTypeRangeDate({ filter }: IVariableTypeRangeDateProps) {
	const { findFieldIndexByGuidDynamicReportVariable, idScreen } = useDynamicFiltersExport();
	const { control, setValue } = useFormContext();
	const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);
	const parameterRangeDays = filter.responseServer.maxAllowedRange ?? DefaultValueParameterEnum.FallbackRangeDate;

	useEffect(() => {
		const { firstDateResult, secondDateResult } = onLoadDateRangePicker(parameterRangeDays);
		setValue(`filtersDinamics.${indexField}.value`, firstDateResult);
		setValue(`filtersDinamics.${indexField}.valueRange`, secondDateResult);
	}, []);

	return (
		<>
			<KogKeyboardDatePickerContainer
				required={filter.responseServer.mandatory}
				idScreen={idScreen("range-date")}
				nameStartDate={`filtersDinamics.${indexField}.value`}
				nameFinalDate={`filtersDinamics.${indexField}.valueRange`}
				parameterRangeDays={parameterRangeDays}
				control={control}
				isFieldInModal
				ignoreKeyValidations={filter.responseServer.mandatory ? [] : ["isInvalidFinalDate", "isInvalidStartDate"]}
			/>
		</>
	);
}

export default VariableTypeRangeDate;
